import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import {
  getSecurityApplicationDetails_action,
  insertUpdateSecurityApplication_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/securityApplication_action/securityApplication_action";
import Modal from "react-modal";
import { data } from "jquery";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import $ from "jquery";
import moment from "moment";
import VendorDetails from "../../vendorDetails";
//
class SecurityApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Remark: "",
      CGST: 0,
      SGST: 0,
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),

      AccountNumber: "",
      BankName: "",
      BeneficiaryAddress: "",
      BeneficiaryName: "",
      GSTNumber: "",
      IFSCCodeValue: "",
      PANNumber: "",
      SwiftCode: "",
      tableList: [],
      totalAmount: "",
      IGST: "",
      Address: "",
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      contactDetailsList: [],
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
      exhDetails: {},
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addSecurityApplication()
      }
      if (confirmationObj.action == 1) {
        this.onPayAndSubmit()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }
  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getSecurityApplicationDetails();
    this.loadscript();
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree, tableList } = this.state;
    let isValid = true;

    const hasTariffEntry = tableList.some(
      (r) => (parseInt(r.DayQuantity) || 0) > 0 || (parseInt(r.NightQuantity) || 0) > 0
    );
    if (!hasTariffEntry) {
      toastError("Please enter at least one guard quantity (Day or Night) in the tariff table.");
      isValid = false;
    }

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr:
          "kindly agree the above disclaimer & Service Partner Terms and conditions mentioned in Guideline",
      });
      isValid = false;
    }

    return isValid;
  }

  getSecurityApplicationDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getSecurityApplicationDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            contactDetailsList: data.contactDetails,
            IGST: data.gst[0]["IGST"] * 100,
            CGST: data.gst[0]["CGST"] * 100,
            SGST: data.gst[0]["SGST"] * 100,
            exhDetails: data.exhDetails && data.exhDetails.length > 0 ? data.exhDetails[0] : {},
          });

          if (data.bankDetails != "") {
            this.setState({
              AccountNumber: data.bankDetails[0]["AccountNumber"],
              BankName: data.bankDetails[0]["BankName"],
              BeneficiaryAddress: data.bankDetails[0]["BeneficiaryAddress"],
              BeneficiaryName: data.bankDetails[0]["BeneficiaryName"],
              GSTNumber: data.bankDetails[0]["GST"],
              IFSCCodeValue: data.bankDetails[0]["IFSCCode"],
              PANNumber: data.bankDetails[0]["PAN"],
              SwiftCode: data.bankDetails[0]["SwiftCode"],
              Address: data.bankDetails[0]["Address"],
            });
          }

          if (data.getDetails != "") {
            this.setState({
              Remark: data.getDetails[0]["Remark"],
              Is_Agree: data.getDetails[0]["Is_Agree"],
            });
          }

          // SecurityApplicationDtl has no SecurityApplicationDescriptionID column,
          // so match saved rows to master descriptions by position (insertion order).
          data.data.forEach((item, i) => {
            const saved = data.getTableDetails && data.getTableDetails[i];
            if (saved) {
              const dayQty = saved.DayQuantity != null && saved.DayQuantity != 0 ? saved.DayQuantity : "";
              const nightQty = saved.NightQuantity != null && saved.NightQuantity != 0 ? saved.NightQuantity : "";
              item.DayQuantity = dayQty;
              item.NightQuantity = nightQty;
              item.dayTotalAmount = item.DayRate * (dayQty !== "" ? dayQty : 1);
              item.nightTotalAmount = item.NightRate * (nightQty !== "" ? nightQty : 1);
              item.Amount = (dayQty !== "" ? item.dayTotalAmount : 0) + (nightQty !== "" ? item.nightTotalAmount : 0);
            } else {
              item.DayQuantity = "";
              item.NightQuantity = "";
              item.dayTotalAmount = item.DayRate;
              item.nightTotalAmount = item.NightRate;
              item.Amount = 0;
            }
          });
          this.setState({ tableList: data.data });
          setTimeout(() => {
            this.sumOfArrayOfObject(this.state.tableList);
          }, 100);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  sumOfArrayOfObject(arrayOfObjects) {
    const sum = arrayOfObjects.reduce((accumulator, currentObject) => {
      return accumulator + currentObject.Amount;
    }, 0);
    this.setState({ totalAmount: sum });
  }

  addSecurityApplication() {
    const { Remark, Is_Agree, tableList } = this.state;
    if (!this.inputValidate()) return;
    const array = [];
    tableList.map((data) => {
      array.push({
        SecurityApplicationDescriptionID: data.SecurityApplicationDescriptionID,
        DayQuantity: data.DayQuantity,
        NightQuantity: data.NightQuantity,
      });
    });
    this.setState({ isLoading: true });
    if (Is_Agree) {
      const ManualFormsID = this.props.location.state?.ManualFormsID || null;
      const ServiceID = this.props.location.state?.ServiceID || null;
      const VendorDetails = this.props.location.state?.VendorDetails || {};
      this.props
        .insertUpdateSecurityApplication_action(
          Remark,
          Is_Agree,
          array,
          ManualFormsID,
          ServiceID,
          VendorDetails
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "Security Services Form Submitted Successfully"
                : "Security Services Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  enterDayQuantity(e, index) {
    const value = e.target.value.replace(/\D/g, "");

    const tableList = this.state.tableList.map((data, i) => {
      if (i !== index) return data;

      const rate = data.DayRate || 0;

      const dayQty = value ? Number(value) : 0;
      const nightQty = data.NightQuantity ? Number(data.NightQuantity) : 0;

      const dayTotalAmount = dayQty * rate;
      const nightTotalAmount = nightQty * rate;

      return {
        ...data,
        DayQuantity: value || "",
        dayTotalAmount,
        nightTotalAmount,
        Amount: dayTotalAmount + nightTotalAmount
      };
    });

    this.setState({ tableList });
    this.sumOfArrayOfObject(tableList);
  }

  enterNightQuantity(e, index) {
    const value = e.target.value.replace(/\D/g, "");

    const tableList = this.state.tableList.map((data, i) => {
      if (i !== index) return data;

      const rate = data.DayRate || 0; // same rate for both shifts

      const dayQty = data.DayQuantity ? Number(data.DayQuantity) : 0;
      const nightQty = value ? Number(value) : 0;

      const dayTotalAmount = dayQty * rate;
      const nightTotalAmount = nightQty * rate;

      return {
        ...data,
        NightQuantity: value || "",
        dayTotalAmount,
        nightTotalAmount,
        Amount: dayTotalAmount + nightTotalAmount
      };
    });

    this.setState({ tableList });
    this.sumOfArrayOfObject(tableList);
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      AccountNumber,
      BankName,
      BeneficiaryAddress,
      BeneficiaryName,
      GSTNumber,
      IFSCCodeValue,
      PANNumber,
      SwiftCode,
      tableList,
      totalAmount,
      IGST,
      Address,
      contactDetailsList,
      CGST,
      SGST,
      StatusID,
      isHideSection,
      is_View, isOpenConfirmationModal, exhDetails, CurrencyID
    } = this.state;

    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? " with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Security Services
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <>
                        <strong>
                          <p className="m-0">Exhibitor Details:</p>
                        </strong>
                        <div class="table-responsive mb-3">
                          <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <strong>Exhibiting Company Name:</strong>
                                </td>
                                <td>{exhDetails.ExhibitorCompanyName || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Booth No.:</strong>
                                </td>
                                <td>{exhDetails.StallName || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Hall No.:</strong>
                                </td>
                                <td>{exhDetails.HallName || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Contact Person:</strong>
                                </td>
                                <td>{exhDetails.ContactPerson || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Designation:</strong>
                                </td>
                                <td>{exhDetails.Designation || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Mobile:</strong>
                                </td>
                                <td>{exhDetails.Mobile || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Email ID:</strong>
                                </td>
                                <td>{exhDetails.PrimaryEmail || "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {contactDetailsList && contactDetailsList.length > 0 && (
                          <>
                            <strong>
                              <p className="m-0">Contact Details:-</p>
                            </strong>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {contactDetailsList.map((data) => (
                                <>
                                  <div
                                    class="table-responsive w-50"
                                    style={{
                                      backgroundColor: "#ebebeb",
                                      marginBottom: "14px",
                                      borderRight: "1px solid lightgray",
                                    }}
                                  >
                                    <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                                      {data.Name && <p className="m-0"><strong>Name:</strong> {data.Name}{" "}</p>}
                                      {data.Phone && <p className="m-0"><strong>Phone:</strong> {data.Phone}</p>}
                                      {data.Fax && <p className="m-0"><strong>Fax:</strong> {data.Fax}</p>}
                                      {data.Mobile && <p className="m-0"><strong>Mobile No.</strong> {data.Mobile}</p>}
                                      {data.PrimaryEmail && <p className="m-0"><strong>Email:</strong> {data.PrimaryEmail}</p>}
                                      {data.SecondaryEmail && <p className="m-0"><strong>Alternate E-mail:</strong> {data.SecondaryEmail}</p>}
                                      {data.Address && <p className="m-0"><strong>Address:</strong> {data.Address}</p>}
                                    </div>
                                  </div>
                                </>
                              ))}
                            </div>
                          </>
                        )}

                        <ul style={{ lineHeight: "25px", textAlign: "left", marginBottom: "14px", listStyleType: "disc", paddingLeft: "20px" }}>
                          <li style={{ listStyleType: "disc" }}>
                            India Exposition Mart Limited is the authorised official Security Service Provider for India ITME 2026.
                          </li>
                          <li style={{ listStyleType: "disc" }}>
                            This Form is applicable only for the Exhibitors and not any other parties working directly or indirectly, with or on behalf of exhibitors.
                          </li>
                        </ul>
                      </>
                    )}

                    {!isHideSection && (
                      <div style={{ marginBottom: "14px", textAlign: "left" }}>
                        <strong>
                          <p className="m-0 mb-2" style={{ textAlign: "left" }}>Terms &amp; Conditions</p>
                        </strong>
                        <ol style={{ lineHeight: "25px", paddingLeft: "20px", marginBottom: "10px", textAlign: "left" }}>
                          <li style={{ textAlign: "left" }}>
                            Security services are confined to guarding individual booths only.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            <strong>Shifts:</strong>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "5px", textAlign: "left" }}>
                              <li>Day shift: 8:00 AM – 8:00 PM</li>
                              <li>Night shift: 8:00 PM – 8:00 AM</li>
                            </ul>
                          </li>
                          <li style={{ textAlign: "left" }}>
                            The company reserves the right to refuse any order. Cancellation of orders will only be accepted when made in writing to Customer Service Department not later than 7 business days prior to the commencement of tenancy period. Cancellation of order is subject to a charge at half of standard rate.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            Final requests for guards must be received by <strong>26-11-2026</strong> for onward intimation to the security service provider.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            Security Guard services charges are <strong>INR 2013</strong> per guard per shift (12 hours).
                          </li>
                          <li style={{ textAlign: "left" }}>
                            Night shift Security Services will not be available during the exhibition days (<strong>04.12.2026 to 09.12.2026</strong>).
                          </li>
                        </ol>

                        <strong>
                          <p className="m-0 mb-2" style={{ textAlign: "left" }}>Please Note:</p>
                        </strong>
                        <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "25px", textAlign: "left" }}>
                          <li>Rates mentioned below are on hire basis and applicable as per dates available.</li>
                          <li>Orders are valid only when accompanied with full payment before the deadline.</li>
                          <li>Please make DD or transfer payable to India Exposition Mart Limited</li>
                        </ul>
                      </div>
                    )}
                    {!isHideSection && <VendorDetails />}
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 ">
                          Security Services{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}

                    <strong><p className="mt-3 mb-2">Tariff for Security Service:</p></strong>
                    <div class="table-responsive">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead>
                          <tr>
                            <th className="text-center">Sr. No</th>
                            <th className="text-center">Date</th>
                            <th className="text-center">No. of Guards Day (A)</th>
                            <th className="text-center">No. of Guards Night (B)</th>
                            {!isHideSection && <th className="text-center">Rate per Guards ({CurrencyID === 1 ? 'INR' : 'USD'})</th>}
                            {!isHideSection && <th className="text-center">Amount C = (A+B)*Rate</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {tableList != "" && tableList.length > 0 ? (
                            tableList.map((data, i) => (
                              <tr>
                                <td className="text-center">{i + 1}</td>
                                <td>{data.Date != null ? moment(data.Date).format("DD/MM/YYYY") : "-"}</td>
                                <td>
                                  <input
                                    className="form-control"
                                    type="text"
                                    disabled={is_View || isDeadlinePassed}
                                    value={data.DayQuantity}
                                    onChange={(e) => this.enterDayQuantity(e, i)}
                                    maxLength={5}
                                  />
                                </td>
                                {/* {!isHideSection && (
                                  <td>{data.NightRate != null ? data.NightRate : "-"}</td>
                                )} */}
                                <td>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={data.NightQuantity}
                                    disabled={is_View || isDeadlinePassed}
                                    onChange={(e) => this.enterNightQuantity(e, i)}
                                    maxLength={5}
                                  />
                                </td>
                                {!isHideSection && (
                                  <td>{data.DayRate != null ? data.DayRate : "-"}</td>
                                )}
                                {!isHideSection && <td className="text-right">{data.Amount != "" ? data.Amount : 0}</td>}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={8}>
                                No record found
                              </td>
                            </tr>
                          )}

                          {!isHideSection && (() => {
                            // ✅ Normalize values (convert to number safely)
                            const total = Number(totalAmount) || 0;
                            const cgstRate = Number(CGST) || 0;
                            const sgstRate = Number(SGST) || 0;

                            // ✅ Calculate taxes (rounded properly)
                            const cgstAmount = Number(((cgstRate / 100) * total).toFixed(2));
                            const sgstAmount = Number(((sgstRate / 100) * total).toFixed(2));

                            // ✅ Grand total
                            const grandTotal = Number((total + cgstAmount + sgstAmount).toFixed(2));

                            return (
                              <>
                                <tr className="text-right">
                                  <td colSpan={4}></td>
                                  <td>
                                    <strong>Total</strong>
                                  </td>
                                  <td>
                                    <strong>{total.toFixed(2)}</strong>
                                  </td>
                                </tr>

                                <tr className="text-right">
                                  <td colSpan={4}></td>
                                  <td>
                                    <strong>CGST @ {cgstRate}%</strong>
                                  </td>
                                  <td>
                                    <strong>{cgstAmount.toFixed(2)}</strong>
                                  </td>
                                </tr>

                                <tr className="text-right">
                                  <td colSpan={4}></td>
                                  <td>
                                    <strong>SGST @ {sgstRate}%</strong>
                                  </td>
                                  <td>
                                    <strong>{sgstAmount.toFixed(2)}</strong>
                                  </td>
                                </tr>

                                <tr className="text-right" style={{ backgroundColor: "#eee" }}>
                                  <td colSpan={4}></td>
                                  <td>
                                    <strong>Grand Total</strong>
                                  </td>
                                  <td>
                                    <strong>{grandTotal.toFixed(2)}</strong>
                                  </td>
                                </tr>
                              </>
                            );
                          })()}
                        </tbody>
                      </table>
                    </div>

                    {!isHideSection && contactDetailsList && contactDetailsList.length > 0 && (
                      <div className="mt-3 mb-2" style={{ textAlign: "left" }}>
                        <strong>
                          <p className="m-0 mb-1" style={{ textAlign: "left" }}>Payment Term:</p>
                        </strong>
                        <p style={{ textAlign: "left", lineHeight: "25px" }}>
                          Order Form shall be valid/entertained only when the same be accompanied with full remittance, in favour of India Exposition Mart Limited Payable at Greater Noida, For IMPS/NEFT/RTGS/Demand Draft/Cheque bank details is as follows: -
                        </p>
                      </div>
                    )}

                    {!isHideSection && contactDetailsList && contactDetailsList.length > 0 && (
                      <div className="table-responsive">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th colSpan={2}><strong>Bank Details</strong></th>
                            </tr>
                          </thead>
                          <tbody>
                            {contactDetailsList.map((item, idx) => (
                              <>
                                {idx > 0 && (
                                  <tr key={`divider-${idx}`}>
                                    <td colSpan={2} style={{ backgroundColor: "#ebebeb", padding: "4px" }}></td>
                                  </tr>
                                )}
                                {item.BeneficiaryName && <tr key={`name-${idx}`}><td style={{ width: "50%" }}><strong>Name</strong></td><td>{item.BeneficiaryName}</td></tr>}
                                {item.AccountNumber && <tr key={`acc-${idx}`}><td><strong>Bank Account Number</strong></td><td>{item.AccountNumber}</td></tr>}
                                {item.BankName && <tr key={`bank-${idx}`}><td><strong>Name of Bank</strong></td><td>{item.BankName}</td></tr>}
                                {item.BankAddress && <tr key={`bankaddr-${idx}`}><td><strong>Bank Address</strong></td><td>{item.BankAddress}</td></tr>}
                                {item.BeneficiaryAddress && <tr key={`benaddr-${idx}`}><td><strong>Bank Branch and Address</strong></td><td>{item.BeneficiaryAddress}</td></tr>}
                                {item.SwiftCode && <tr key={`swift-${idx}`}><td><strong>Swift Code</strong></td><td>{item.SwiftCode}</td></tr>}
                                {item.IFSCCode && <tr key={`ifsc-${idx}`}><td><strong>RTGS/IFSC Code</strong></td><td>{item.IFSCCode}</td></tr>}
                                {item.PAN && <tr key={`pan-${idx}`}><td><strong>PAN No</strong></td><td>{item.PAN}</td></tr>}
                                {item.GST && <tr key={`gst-${idx}`}><td><strong>GST No</strong></td><td>{item.GST}</td></tr>}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                  </div>
                </div>
                {!isHideSection && (
                  <div class="row m-1">
                    <form>
                      <strong>
                        {" "}
                        <label>Additional Note:</label>
                      </strong>
                      <textarea
                        class="form-control"
                        value={Remark}
                        disabled={is_View || isDeadlinePassed}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        maxLength={300}
                        rows="3"
                      ></textarea>
                      <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                        <input
                          type="checkbox"
                          checked={Is_Agree}
                          disabled={is_View || isDeadlinePassed}
                          onChange={(e) =>
                            this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                          }
                        />
                        <strong>
                          {" "}
                          I confirm the above requirements and disclaimer
                          <span className="required">*</span>.
                        </strong>
                      </label>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {Is_AgreeErr}
                        </span>
                      }
                    </form>
                  </div>
                )}
              </div>
              {!isHideSection && (
                <div className="row">
                  {currentDate > DeadlineDate && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}
              {!isHideSection && <div className="d-flex gap-1 justify-content-end mt-0">
                <button
                  type="button"
                  className="btn btn-aqua rounded-1 d-block"
                  style={{ marginRight: 10 }}
                  disabled={currentDate > DeadlineDate}
                  // onClick={() => this.addSecurityApplication()}
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                >
                  {this.state.StatusID == 0 ? "Submit" : "Update"}
                </button>
                <button
                  className="btn btn-gray rounded-1 d-block"
                  onClick={() => this.handleCancel()}
                >
                  Back
                </button>
              </div>}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, { getSecurityApplicationDetails_action, insertUpdateSecurityApplication_action })(
    SecurityApplication
  )
);
